import { useEffect, useState } from "react";
import { useRemanso } from "@/context/RemansoContext";
import { ROUTES, routeById } from "@/lib/routes";

export const RouteChooser = ({ prefix }) => {
  const { bound, route, chooseRoute, draftBody, addStarter, thread, live } = useRemanso();
  const started = !!draftBody.trim() || thread.length > 0;
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!started) setOpen(false); }, [started]);
  if (!bound) return null;
  const current = routeById(route);
  if (started && !open) {
    return (
      <p className="text-[14px] text-sec" data-testid={`${prefix}-route-summary`}>
        <span>Ruta · </span><span className="text-tinta font-medium">{current.name}</span><span> · </span>
        <button type="button" className="text-acento-texto hover:underline underline-offset-2" onClick={() => setOpen(true)}
          data-testid={`${prefix}-route-change`}>Cambiar</button>
      </p>
    );
  }
  const pick = (id) => { chooseRoute(id); if (started) setOpen(false); };
  const used = new Set(thread.map((iv) => iv.text));
  const starters = draftBody.trim() ? [] : current.starters.filter((s) => !used.has(s));
  return (
    <div data-testid={`${prefix}-routes`}>
      <p className="eyebrow text-xs mb-3">Ruta de escritura</p>
      <div className="flex flex-wrap gap-1.5">
        {ROUTES.map((r) => (
          <button key={r.id} type="button" aria-pressed={r.id === current.id} onClick={() => pick(r.id)}
            className={`chip text-[13px] ${r.id === current.id ? "active" : ""}`} data-testid={`${prefix}-route-${r.id}`}>
            {r.name}
          </button>
        ))}
      </div>
      <p className="text-[13px] text-sec mt-3" data-testid={`${prefix}-route-desc`}>{current.desc}</p>
      {starters.length > 0 && (
        <div className="mt-3 flex flex-col gap-2">
          {starters.map((s, i) => (
            <button key={s} type="button" disabled={!!live} onClick={() => addStarter(s)} data-testid={`${prefix}-starter-${i}`}
              className="text-left rounded-[8px] border-[1.5px] border-dashed border-borde px-3 py-2 text-[14px] text-tinta hover:bg-resaltado transition-colors">
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
